module.exports = __webpack_public_path__ + "566aa8ed69a2bec0e33e866499eb3b59.MP3";